export const badmintonRules = [
  {
    title: 'Court Dimensions',
    type: 'info',
    diagram: {
      label: 'Court Size',
      value: '44\' × 20\''
    },
    points: [
      'Singles court: 44 feet long × 17 feet wide',
      'Doubles court: 44 feet long × 20 feet wide',
      'Net height: 5 feet 1 inch at edges, 5 feet at center',
      'Service courts divided by center line and short service line'
    ],
    keyFact: 'Badminton courts are smaller than tennis courts but require incredible speed and agility!'
  },
  {
    title: 'Scoring System',
    type: 'info',
    diagram: {
      label: 'Points to Win',
      value: '21'
    },
    points: [
      'Rally scoring: point on every rally',
      'Games won at 21 points (must win by 2)',
      'If tied at 20-20, play continues until 2-point lead or 30 points',
      'Best of 3 games wins the match'
    ],
    keyFact: 'At 29-29, the next point wins the game - called the "golden point"!'
  },
  {
    title: 'Service Rules',
    type: 'do',
    diagram: {
      label: 'Service Style',
      value: 'Underhand'
    },
    points: [
      'Must serve underhand below waist height',
      'Racket head must be below hand at contact',
      'Serve diagonally into opponent\'s service court',
      'Feet must remain stationary until shuttle is struck'
    ],
    keyFact: 'The shuttlecock must be hit below 1.15 meters (about 45 inches) from the ground!'
  },
  {
    title: 'Shuttlecock Speed',
    type: 'info',
    diagram: {
      label: 'Smash Speed',
      value: '200+ mph'
    },
    points: [
      'Fastest racket sport in the world',
      'Smashes can exceed 200 mph (320 km/h)',
      'Shuttlecock rapidly decelerates due to drag',
      'Professional rallies can last 90+ shots'
    ],
    keyFact: 'Badminton is the fastest racket sport - much faster than tennis or squash!'
  },
  {
    title: 'Let Calls',
    type: 'info',
    points: [
      'Shuttle caught in net on serve - replay',
      'Server serves before receiver is ready - replay',
      'Shuttle disintegrates during play - replay',
      'Line judge unsighted - replay (umpire decision)'
    ],
    keyFact: 'Unlike tennis, there are no lets for net cords during rallies in badminton!'
  },
  {
    title: 'Faults',
    type: 'dont',
    points: [
      'Shuttle lands outside boundary lines',
      'Shuttle fails to cross net',
      'Shuttle touches player or clothing',
      'Player touches net with body or racket during play'
    ],
    keyFact: 'Hitting the shuttle twice in succession is a fault, even if accidental!'
  }
];

export const badmintonGoverningBodies = [
  {
    name: 'BWF',
    description: 'Badminton World Federation - International governing body with 197 member associations. Organizes major tournaments and sets global standards.',
    website: 'https://bwfbadminton.com'
  },
  {
    name: 'USA Badminton',
    description: 'National governing body for badminton in the United States, overseeing national teams, tournaments, and player development.',
    website: 'https://www.usabadminton.org'
  }
];

export const badmintonTournaments = [
  {
    name: 'BWF World Championships',
    description: 'Annual tournament featuring the world\'s top players competing for individual world titles in five disciplines.',
    website: 'https://bwfbadminton.com/events/world-championships/'
  },
  {
    name: 'Olympic Badminton',
    description: 'Badminton at the Summer Olympics featuring men\'s singles, women\'s singles, men\'s doubles, women\'s doubles, and mixed doubles.',
    website: 'https://bwfbadminton.com/events/olympics/'
  },
  {
    name: 'All England Open',
    description: 'The oldest and most prestigious badminton tournament, often called the unofficial world championship.',
    website: 'https://www.allenglandbadminton.com'
  },
  {
    name: 'Thomas & Uber Cup',
    description: 'Biennial international team championships for men (Thomas Cup) and women (Uber Cup).',
    website: 'https://bwfbadminton.com/events/thomas-uber-cup/'
  }
];

export const badmintonResources = [
  {
    name: 'USA Badminton Events',
    website: 'https://www.usabadminton.org/events'
  },
  {
    name: 'BWF World Rankings',
    website: 'https://bwfbadminton.com/rankings/'
  },
  {
    name: 'BWF Tournament Calendar',
    website: 'https://bwfbadminton.com/calendar/'
  }
];
